import uiRouter from 'angular-ui-router';
import errorPageComponent from './errorPage.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let errorPageModule = angular.module('components.errorPage', [
  uiRouter
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.ERROR, {
        url: ROUTES.ERROR,
        component: 'errorPage',
        params: {
          stateName: null,
          errorMessage: null,
          stateRedirection: null,
        },
        data: {
          requiresAuth: false
        }
      });
  })

  .component('errorPage', errorPageComponent)

  .name;

export default errorPageModule;



// WEBPACK FOOTER //
// ./client/app/features/errorPage/errorPage.js